export const STEPPER_ROUTES = {
  PAYMENT_INITIAL: '/initial',
  PAYMENT_SELECT_METHOD: '/select',
  PAYMENT_CRYPTO_CONFIRMATION: '/crypto-confirm',
  PAYMENT_CRYPTO_AWAITING: '/crypto-awaiting',
  PAYMENT_DEBIT_CONFIRMATION: '/debit-confirm',
  PAYMENT_DEBIT_AWAITING: '/debit-awaiting',
  PAYMENT_SUCCESS: '/success',
  OWNED_NFT: '/owned-nft',
};
